import React, { useEffect, useState } from 'react';
import Graph1 from './graph/Graph1'
import Graph2 from './graph/Graph2'
import estat from './img/estat.png'
import { Link } from 'react-router-dom';
import ReplyIcon from '@material-ui/icons/Reply';
const App = () => {
	return (
		<div className="bg-white p-5 min-vh-100">
			<div><Link to={'/'} className="p-3"><ReplyIcon className="pb-2" style={{fontSize:'x-large', cursor:'pointer'}}/> <span style={{fontSize:'large'}}>Back</span></Link></div>
		<div className="text-center">
			
			<img src={estat} />
            <Graph1 />
            <Graph2 />
		</div>
		</div>
	);
};
export default App;
